/**
 * Resource that represents a ProductGroup, an entity used to filter inventory items.
 *
 * @name ProductGroup
 * @class
 * @augments TmrResource
 */
function ProductGroupFactory(TmrResource) {
  'ngInject'
  return TmrResource('ProductGroup')
}

export const factory = ['ProductGroup', ProductGroupFactory]
